/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dashboard_Case_CountInputs */

const en_dashboard_case_count = /** @type {(inputs: Dashboard_Case_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cases`)
};

const pt_br2_dashboard_case_count = /** @type {(inputs: Dashboard_Case_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} casos`)
};

/**
* | output |
* | --- |
* | "{count} cases" |
*
* @param {Dashboard_Case_CountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_case_count = /** @type {((inputs: Dashboard_Case_CountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Case_CountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_case_count(inputs)
	return pt_br2_dashboard_case_count(inputs)
});